module.exports = __webpack_public_path__ + "static/media/fb-black.7d3157d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/fb-black.svg
// module id = 219
// module chunks = 0